// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"edcDataFormDownload_wrapper__35iG9","condition":"edcDataFormDownload_condition__2n9xU"};